import { memo } from 'react';
import tw, { TwStyle } from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { expandSpeakerLabelStyleMap } from '@utils/colorUtils';

const StyledSpeakerLabel = tw.div`inline-block font-semibold text-[16px] py-[4px] px-[12px] rounded-full border border-solid leading-[1] tracking-[0.16px]`;

const SPEAKER_LABEL_STYLE_MAPPER: { [key: string]: TwStyle } = {
  '0': tw`bg-spec-IAB-filter-bg text-spec-IAB-filter-text border-spec-IAB-filter-text` as TwStyle,
  '1': tw`bg-spec-publish-date-filter-bg text-spec-publish-date-filter-text border-spec-publish-date-filter-text` as TwStyle,
  '2': tw`bg-spec-review-filter-bg text-spec-review-filter-text border-spec-review-filter-text` as TwStyle,
  '3': tw`bg-spec-rating-filter-bg text-spec-rating-filter-text border-spec-rating-filter-text` as TwStyle,
  '4': tw`bg-spec-entites-filter-bg text-spec-entites-filter-text border-spec-entites-filter-text` as TwStyle,
  '5': tw`bg-spec-review-filter-bg text-spec-review-filter-text border-spec-review-filter-text` as TwStyle,
  '6': tw`bg-spec-duration-filter-bg text-spec-duration-filter-text border-spec-duration-filter-text` as TwStyle,
  '7': tw`bg-spec-apple-filter-bg text-spec-apple-filter-text border-spec-apple-filter-text` as TwStyle,
  '8': tw`bg-spec-show-type-filter-bg text-spec-show-type-filter-text border-spec-show-type-filter-text` as TwStyle,
  '9': tw`bg-spec-author-filter-bg text-spec-author-filter-text border-spec-author-filter-text` as TwStyle,
};

const expandedLabelStyles = expandSpeakerLabelStyleMap(SPEAKER_LABEL_STYLE_MAPPER, 40);

export const SpeakerLabel = memo(({ speaker }: { speaker: number | null | undefined }) => {
  const { t } = useTranslation();

  if (!speaker && typeof speaker !== 'number') return null;

  return (
    <StyledSpeakerLabel css={expandedLabelStyles[speaker]}>
      {t('insights.episode_details_drawer.episode_details_sidebar.speaker_label', {
        number: Number(speaker) + 1,
      })}
    </StyledSpeakerLabel>
  );
});

SpeakerLabel.displayName = 'SpeakerLabel';
